import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckboxWithLabel, CheckoutSection, CheckoutSectionHeadline, } from "../components";
import { useCheckout } from "../hooks/api";
import styled from "styled-components";
import { useField } from "@/pages/CheckoutPage/hooks";
const ContentWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
export const NewsletterSection = ({ defaultValues, options, schema, }) => {
    const { errors: optinNewsletterErrors, fieldState: optinNewsletter, setFieldState: setOptinNewsletter, } = useField("optinNewsletter", schema, Boolean(defaultValues?.optinNewsletter) ?? false);
    const { content, label, title, } = options ?? {
        content: undefined,
        label: undefined,
        title: undefined,
    };
    const { isFetching, isLoading } = useCheckout();
    return (_jsxs(CheckoutSection, { children: [_jsx(CheckoutSectionHeadline, { children: title ?? "Exklusive Angebote & Aktionen sichern" }), label && (_jsxs(ContentWrapper, { children: [_jsx(CheckboxWithLabel, { checked: optinNewsletter, error: optinNewsletterErrors?.[0]?.message, onChange: () => {
                            setOptinNewsletter(!optinNewsletter);
                        }, label: label, disabled: isLoading || isFetching, qaName: "optin-newsletter" }), content] }))] }));
};
